import React from 'react'
import styled from 'styled-components/macro'
import { AiOutlineInfoCircle } from 'react-icons/ai'

type Props = {
  children?: React.ReactNode
}
const ErrorMessageFormat = ({ children }: Props) => {
  return (
    <Wrap>
      <AiOutlineInfoCircle style={{ opacity: '0.5' }} />
      &nbsp;{children}
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  align-items: center;
  white-space: normal;
  word-break: break-all;
  color: #8a8a8a;
`
export default ErrorMessageFormat
